import { render, staticRenderFns } from "./EventRubricsWidget.vue?vue&type=template&id=737b3fb2&scoped=true&"
import script from "./EventRubricsWidget.vue?vue&type=script&lang=js&"
export * from "./EventRubricsWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventRubricsWidget.vue?vue&type=style&index=0&id=737b3fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b3fb2",
  null
  
)

export default component.exports